__webpack_require__.p = "/GenAI_Concepts/";